module.exports = __webpack_public_path__ + "4b83e0793207bb900b2c4fd30568265d.png";